
export default {
  name: 'FilterBasic',
  // eslint-disable-next-line vue/require-prop-types
  props: ['dataFilter', 'buttonLoadMore', 'limit', 'isProduct', 'textValue', 'textName', 'keyFilter', 'updateState', 'hiddenCollapse'],
  data() {
    return {
      listData: [],
      listValue: [],
      showListFilter: true,
      loadMore: false,
      itemValue: 'id',
      itemName: 'value'
    }
  },
  watch: {
    listValue() {
      this.changeListValue()
    },
    'updateState.status'() {
      const data = []
      this.dataFilter.list.forEach(filter => {
        if (this.updateState.list.includes(String(filter[this.itemValue])) || this.updateState.list.includes(filter[this.itemValue])) {
          data.push(filter[this.itemValue])
        }
      })
      this.listValue = data
    }
  },
  created() {
    if (this.textValue) {
      this.itemValue = this.textValue
    }
    if (this.textName) {
      this.itemName = this.textName
    }
  },
  methods: {
    resetValidate(ref) {
      this.$refs.accountForm.fields.find((f) => f.prop === ref).clearValidate()
      this.accountForm.errors[ref] = ''
    },
    checkShow(index) {
      if (this.buttonLoadMore !== true) return true
      if ((this.loadMore === false) && (index >= this.limit)) return false
      return true
    },
    changeListValue() {
      const list = []
      const listValue = []
      this.dataFilter.list.forEach(data => {
        if (this.listValue.includes(data[this.itemValue])) {
          list.push(data[this.itemName])
          listValue.push(data[this.itemValue])
        }
      })
      this.$emit('change', {
        type: this.keyFilter,
        value: list,
        list: listValue,
        title: this.dataFilter.title
      })
    }
  }
}
